import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.element.addEventListener('change', () => {
      // remove error message if one exists
      const e = this.element
        .closest('.checkbox-input-container')
        .querySelector('.error-message');
      if (e) {
        e.remove();
      }
    });
  }
}
